"use strict";

(function (global) {
  /**
  * Drag & drop для списка объектов проводника
  * @namespace Core.objectList.dragging
  * @since 5.1.0.1523
  */
  global.dragging = {
    draggable: ".List",
    jDraggable: null,
    isCopyKeyPressed: false,
    isCancelKeyPressed: false,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Инициализация Drag & drop
    * @function Core.objectList.dragging.init
    * @since 5.1.0.1523
    * @return {Core.objectList.dragging}
    */
    init: function () {
      var me = this;
      if (WA.ENV.isTouch()) {
        log.info('DRAG&DROP', 'Drag & Drop is disabled for touch devices');
        return;
      }
      log.info('DRAG&DROP', 'Drag & Drop initializing for objectList');

      me.refreshObjects();

      me.dragSetup()
      .dropSetup()
      .enableCopyButton();

      WA.ObjectListInit.done(function () {
        WA.CR.objectList.bind('itemsChange', function () {
          me.refreshObjects()
            .enableCopyButton()
            .dragSetup()
            .dropSetup();
        });
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обновить jquery объекты, когда обнвовляется дерево
    * @function Core.objectList.dragging.refreshObjects
    * @since 5.1.0.1523
    * @return {Core.folderTree.dragAndDrop}
    */
    refreshObjects: function () {
      var me = this;
      me.jDraggable = $(me.draggable).not('drag_binded');
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * При нажатии на CTRL при переносе должно происходить копирование ссылок
    * а не перенос.
    * @function Core.objectList.dragging.enableCopyButton
    * @since 5.1.0.1523
    * @return {Core.objectList.dragging}
    */
    enableCopyButton: function () {
      this.jDraggable.bind("drag keydown", Core.dropping.enableCopyButton);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Настройка элементов, которые можно перетаскивать
    * Здесь же в функции helper формируется представление переносимого
    * объекта.
    * @function Core.objectList.dragging.dragSetup
    * @since 5.1.0.1523
    * @return {Core.objectList.dragging}
    * @see #91763
    * @see #93576
    * @see http://goo.gl/QIkKPS
    */
    dragSetup: function () {
      var me = this;
      var MaxVisuallyStackedObjects = 3;

      var settings = {
        helper: function () {
          var jObject = $(this);

          var jAttachedToCursorItem;
          if (!jObject.hasClass('selected')) WA.CR.objectList.selectItemByID(jObject.attr('id'));

          var count = WA.CR.objectList.getSelectedItems().length;
          if (count == 1) jObject.addClass('lastDrag');

          jAttachedToCursorItem = $('<div class="movedStack"></div>');
          for (var i = 1; i < count && i < MaxVisuallyStackedObjects; i++) {
            jAttachedToCursorItem.prepend('<div class="object-list-item_stacked"></div>');
          }
          jAttachedToCursorItem.append($(this).clone().addClass('movedItem'));

          return jAttachedToCursorItem;
        },

        revert: 'invalid',
        //scroll: false,
        cursorAt: { left: 13, top: 13 },
        cursor: "grabbing",
        distance: 10,
        cancel: '.fastActions'
      }

      me.jDraggable.draggable(settings).addClass('drag_binded');
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Настройка элементов, В(!) которые можно перетаскивать
    * @function Core.folderTree.objectList.dropSetup
    * @since 5.1.0.1523
    * @return {Core.folderTree.objectList}
    */
    dropSetup: function () {
      Core.dropping.init();
      return this;
    }
  }


})(window.Core.objectList);


